<template>
  <v-card class="hide-overflow fill-height fill-width" color="white lighten-1" lighten>
    <v-toolbar color="#333333">
      <v-icon color="white" class="mr-2">flip</v-icon>
      <v-toolbar-title style="color: white" class="font-weight-light">Flip</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="retornar(false)">
        <v-icon color="white">cancel</v-icon>
      </v-btn>
    </v-toolbar>
    <iframe
      allowfullscreen
      referrerpolicy="origin-when-cross-origin"
      :src="urlFlipPage + '?flippage=' + urlFlip"
      title="Flip"
      width="100%"
      height="88%"
      style="border: none"
    ></iframe>
  </v-card>
</template>
<script>
export default {
  props: {
    urlFlip: String
  },
  data() {
    return { urlFlipPage: null };
  },
  methods: {
    retornar(valor) {
      this.$emit("update:dialogFlip", valor);
    }
  },
  beforeMount() {
    var urlApi = (window.location.host.includes("localhost") ? "http://localhost" : window.location.host) + "/";
    if (!urlApi.includes("http")) {
      urlApi = "https://" + urlApi;
    }
    this.urlFlipPage = urlApi + "flippage/";

    /* TODO: testar
    npm install vue3-pdf
      <vue-pdf :src="pdfUrl"></vue-pdf>


    https://www.npmjs.com/package/@labsforge/flipbook

    https://www.npmjs.com/package/page-flip

    https://www.npmjs.com/package/flipbook-vue

    e outros aqui:
    https://npm.io/search/keyword:flipbook

    */
  }
};
</script>
